// TODO: need mapping with the reason returned from BE,
export const REJECT_REASON_LIST = {
  UPDATE_CHECK_AMOUNT: 'Check amount could not be confirmed. Please review and re-enter amount.',
  UPLOAD_BACK_SIDE_IMAGE: 'Review and confirm your signature endorsement is on back of check.',
  UPLOAD_FRONT_SIDE_IMAGE: 'Review and confirm payer signature is on front of check.',
  UPLOAD_BACK_SIDE_IMAGE_ONLY_MOBILE:
    'Review and confirm that "For Mobile Deposit Only" is under signature endorsement on back of check.'
};
